import React from 'react'
import Button from '../elements/Button'
import IconText from '../elements/IconText'

import { formatRawNumber } from '../../Helpers'

type Props = {
  action: any,
  count: number,
  isDisabled?: boolean,
}

ButtonComments.defaultProps = {
  isDisabled: false,
}

function ButtonComments(props: Props) {
  const { action, count, isDisabled } = props

  return (
    <Button kind="icon" onClick={action} disabled={isDisabled}>
      <IconText
        icon={{ type: 'fal', name: 'comment' }}
        text={formatRawNumber(count)}
        cnames="user--meta--comments"
      />
    </Button>
  )
}

export default ButtonComments
